import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../services/api.service';
import {FunctionsService} from '../services/functions.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-essentials',
    templateUrl: './essentials.component.html',
    encapsulation: ViewEncapsulation.None
})
export class EssentialsComponent implements OnInit {
    categories: any;
    allCategories: Array<any>;
    categoriesPart:  Array<any>;

    essentials: any;
    next: string;
    slug: string;
    title: string;

    constructor(private api: ApiService,
                private route: ActivatedRoute) {
        this.essentials = [];
        this.title = '';
        this.allCategories = [];
        this.categoriesPart = [];
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            if (this.slug !== params.get('slug')) {
                this.essentials = [];
            }
            this.slug = params.get('slug');
            this.getEssentials(this.slug);
        });
        this.getCategories();
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html);
    }

    loadMore(): void {
        this.getEssentials(this.slug);
    }

    private getCategories(): void {
        this.api.getEssentialCategories()
            .subscribe(categories => {
                this.allCategories = categories;
                this.allCategories['results'].forEach(category => {
                    if (category.essentials.length > 10) {
                        category.collapsed = true;
                        category.hasMore = true;
                    }
                });

                this.categoriesPart = JSON.parse(JSON.stringify(this.allCategories));
                this.categoriesPart['results'].forEach(category => {
                    category.essentials = category.essentials.slice(0, 10);
                });
                this.categories = this.categoriesPart;
            });
    }

    private getEssentials(slug: string): void {
        if (slug) {
            this.api
                .getEssentialsByCategorySlug(slug, this.next)
                .subscribe(essentials => {
                    this.next = essentials.next;
                    this.title = essentials.results[0].categories.category;
                    this.essentials = this.essentials.concat(essentials.results);
                });
        } else {
            this.api
                .getEssentials(this.next)
                .subscribe(essentials => {
                    this.next = essentials.next;
                    this.essentials = this.essentials.concat(essentials.results);
                });
        }
    }

    showMore(type: string, catGroup?): void {
        switch (type) {
            case 'category': {
                if (catGroup) {
                    const group = this.allCategories['results'].filter(fGroup => fGroup.id === catGroup.id);
                    if (catGroup.collapsed) {
                        catGroup.essentials = group[0].essentials;
                        catGroup.collapsed = false;
                    } else {
                        catGroup.essentials = catGroup.essentials.slice(0, 10);
                        catGroup.collapsed = true;
                    }
                }
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/essentials/essentials.component.ts